// Kitchen Display System Types

export enum OrderStatus {
  CART = 'CART',
  SUBMITTED = 'SUBMITTED',
  PREPARING = 'PREPARING',
  READY = 'READY',
  SERVED = 'SERVED',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
}

export enum OrderPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
  DELAYED = 'DELAYED',
}

export enum OrderItemStatus {
  PENDING = 'PENDING',
  PREPARING = 'PREPARING',
  READY = 'READY',
  SERVED = 'SERVED',
}

export interface KitchenStation {
  id: string;
  restaurantId: string;
  name: string;
  color: string;
  displayOrder: number;
  active: boolean;
  description?: string;
  avgPrepTimeMinutes?: number;
}

export interface KDSOrderItem {
  id: string;
  productId: string;
  productName: string;
  quantity: number;
  unitPrice: number;
  customizations?: string;
  itemStatus: OrderItemStatus;
  preparationStartedAt?: string;
  completedAt?: string;
  preparedBy?: string;
  kitchenStationId?: string;
  kitchenStationName?: string;
  kitchenStationColor?: string;
}

export interface KDSOrder {
  id: string;
  tableNumber: string;
  customerName?: string;
  status: OrderStatus;
  priority: OrderPriority;
  items: KDSOrderItem[];
  total: number;
  notes?: string;
  estimatedPreparationTime?: number;
  actualPreparationTime?: number;
  createdAt: string;
  preparationStartedAt?: string;
  readyAt?: string;
  elapsedMinutes: number;
  isDelayed: boolean;
}

export interface UpdateOrderItemStatusRequest {
  status: OrderItemStatus;
  preparedBy?: string;
}

export interface UpdateOrderPriorityRequest {
  priority: OrderPriority;
}

export interface BumpOrderRequest {
  targetStatus?: OrderStatus;
}
